export const homeTranslations = {
  en: {
    hero: {
      badge: '🚀 Trusted by 500+ users',
      title: 'Your Money, Your Future, Under Control',
      subtitle: 'Discover the power of compound interest and build wealth that lasts generations. Join thousands of users already on their financial journey.',
      cta: 'Start Building Wealth',
      ctaSecondary: 'Learn How It Works'
    },
    home: {
      valuePillars: {
        title: 'Build Your Financial Future with Confidence',
        subtitle: 'Discover the tools and knowledge you need to make smarter financial decisions and achieve your goals',
        pillar1: {
          title: 'Powerful Calculators',
          description: 'Precision tools for compound interest, mortgages, savings plans, and salary projections to plan every aspect of your finances.'
        },
        pillar2: {
          title: 'Financial Education',
          description: 'Learn proven strategies for investing, saving, and growing your wealth with expert guides and practical articles.'
        },
        pillar3: {
          title: 'Personalized Planning',
          description: 'Create customized savings and investment plans tailored to your unique goals and financial situation.'
        }
      },
      info: {
        title: 'Learn About Compound Interest and How to Save Money',
        description: 'Compound interest is the eighth wonder of the world. He who understands it, earns it; he who doesn\'t, pays it. Discover how small investments can grow exponentially over time.',
        cta: 'View More Resources'
      },
      hook: {
        title: 'The Secret Millionaires Don\'t Want You to Know',
        description: 'Einstein called compound interest the "8th wonder of the world." Start building your wealth systematically and watch your money work for you over time.',
        ctaPrimary: 'Calculate My Future',
        ctaSecondary: 'See Examples'
      },
      tools: {
        title: 'Wealth-Building Tools That Actually Work',
        useTool: 'Use Tool'
      },
      articles: {
        title: 'Featured Financial Articles',
        subtitle: 'Explore our most popular guides to master your personal finances and build lasting wealth',
        viewAll: 'View All Articles'
      },
      savings: {
        title: 'Savings Planner: Your Guide to Smart Family Savings',
        subtitle: 'Discover how to save money with our monthly savings system designed to maximize your savings account and achieve your total savings goal',
        feature1: {
          title: 'Personalized Monthly Savings Plan',
          description: 'Create a monthly savings plan tailored to your financial situation. Our savings planner helps you set realistic goals for your savings account.'
        },
        feature2: {
          title: 'Optimized Family Savings',
          description: 'Family savings strategies that the whole family can follow. Learn how to save money on household expenses and maximize your available money.'
        },
        feature3: {
          title: 'Long-Term Savings',
          description: 'Plan your long-term savings with precise projections. See how your savings account can grow to reach your desired total savings.'
        },
        cta: 'Create My Savings Plan',
        ctaSecondary: 'Learn more'
      },
      benefits: {
        title: '🔥 Why Smart Money Chooses Finanzly',
        subtitle: 'Join the financial elite who understand that time is the most valuable asset in wealth building',
        benefit1: {
          title: 'Proven Tools',
          description: 'Our calculators use industry-standard formulas trusted by financial advisors worldwide for accurate projections.'
        },
        benefit2: {
          title: 'Expert Community',
          description: 'Connect with thousands of users sharing strategies, tips, and celebrating financial milestones together.'
        },
        benefit3: {
          title: 'Precise Planning',
          description: 'Advanced calculations ensure your financial projections are accurate, eliminating guesswork from your planning.'
        }
      },
      urgency: {
        title: 'Every Day You Wait Matters',
        description: 'Time is your most powerful ally in building wealth. The power of compound interest works best when you start early. Don\'t let procrastination cost you your financial future.',
        cta: 'Start My Financial Journey',
        note: '✅ 100% Free • No Credit Card Required'
      },
      gettingStarted: {
        title: 'Start in 3 Simple Steps',
        subtitle: 'Take control of your finances today with our easy-to-use tools',
        step1: {
          title: 'Choose Your Tool',
          description: 'Select from our calculators: compound interest, mortgages, savings plans, or salary comparisons based on your financial goal.'
        },
        step2: {
          title: 'Enter Your Data',
          description: 'Input your current financial information. Our calculators guide you with clear instructions and real-time results.'
        },
        step3: {
          title: 'Get Your Plan',
          description: 'Receive detailed projections and actionable insights. Download reports in PDF to track your progress over time.'
        }
      },
      cta: {
        title: 'Ready to Build Your Future?',
        subtitle: 'Start building wealth today with our free financial tools. Your journey to financial freedom begins now!',
        primary: 'Start Free Now',
        secondary: 'View Premium Plans'
      }
    }
  },
  es: {
    hero: {
      badge: '🚀 Más de 500 usuarios confían en nosotros',
      title: 'Tu Dinero, Tu Futuro, Bajo Control',
      subtitle: 'Descubre el poder del interés compuesto y construye riqueza que dure generaciones. Únete a miles de usuarios ya en su viaje financiero.',
      cta: 'Comienza a Construir Riqueza',
      ctaSecondary: 'Aprende Cómo Funciona'
    },
    home: {
      valuePillars: {
        title: 'Construye Tu Futuro Financiero con Confianza',
        subtitle: 'Descubre las herramientas y el conocimiento que necesitas para tomar decisiones financieras más inteligentes y alcanzar tus metas',
        pillar1: {
          title: 'Calculadoras Potentes',
          description: 'Herramientas de precisión para interés compuesto, hipotecas, planes de ahorro y proyecciones salariales para planificar cada aspecto de tus finanzas.'
        },
        pillar2: {
          title: 'Educación Financiera',
          description: 'Aprende estrategias probadas para invertir, ahorrar y hacer crecer tu patrimonio con guías de expertos y artículos prácticos.'
        },
        pillar3: {
          title: 'Planificación Personalizada',
          description: 'Crea planes de ahorro e inversión personalizados adaptados a tus objetivos únicos y situación financiera.'
        }
      },
      info: {
        title: 'Aprende Sobre el Interés Compuesto y Como Ahorrar Dinero',
        description: 'El interés compuesto es la octava maravilla del mundo. Quien lo entiende, lo gana; quien no, lo paga. Descubre cómo pequeñas inversiones pueden crecer exponencialmente con el tiempo.',
        cta: 'Ver Más Recursos'
      },
      hook: {
        title: 'El Secreto que los Millonarios No Quieren que Sepas',
        description: 'Einstein llamó al interés compuesto la "8ª maravilla del mundo." Comienza a construir tu riqueza de manera sistemática y mira cómo tu dinero trabaja para ti con el tiempo. Optimiza tu cuenta de ahorro, planifica tu ahorro mensual y descubre como ahorrar dinero de forma inteligente.',
        ctaPrimary: 'Calcula Mi Futuro',
        ctaSecondary: 'Ver Ejemplos'
      },
      tools: {
        title: 'Herramientas de Construcción de Riqueza que Realmente Funcionan',
        useTool: 'Usar Herramienta'
      },
      articles: {
        title: 'Artículos Financieros Destacados',
        subtitle: 'Explora nuestras guías más populares para dominar tus finanzas personales y construir riqueza duradera',
        viewAll: 'Ver Todos los Artículos'
      },
      savings: {
        title: 'Planificador de Ahorro: Tu Guía para el Ahorro Familiar Inteligente',
        subtitle: 'Descubre como ahorrar dinero con nuestro sistema de ahorro mensual diseñado para maximizar tu cuenta de ahorro y lograr tu ahorro total objetivo',
        feature1: {
          title: 'Plan de Ahorro Mensual Personalizado',
          description: 'Crea un plan de ahorro mensual adaptado a tu situación financiera. Nuestro planificador de ahorro te ayuda a establecer metas realistas para tu cuenta de ahorro.'
        },
        feature2: {
          title: 'Ahorro Familiar Optimizado',
          description: 'Estrategias de ahorro familiar que toda la familia puede seguir. Aprende como ahorrar dinero en gastos del hogar y maximiza tu dinero disponible.'
        },
        feature3: {
          title: 'Ahorro a Largo Plazo',
          description: 'Planifica tu ahorro a largo plazo con proyecciones precisas. Ve cómo tu cuenta de ahorro puede crecer hasta alcanzar tu ahorro total deseado.'
        },
        cta: 'Crear Mi Plan de Ahorro',
        ctaSecondary: 'Aprende a ahorrar'
      },
      benefits: {
        title: '🔥 Por Qué el Dinero Inteligente Elige Finanzly',
        subtitle: 'Únete a la élite financiera que entiende que el tiempo es el activo más valioso en la construcción de riqueza',
        benefit1: {
          title: 'Resultados Probados',
          description: 'Nuestros usuarios promedian 8.7% de retornos anuales - superando al 90% de las cuentas de ahorro tradicionales y muchos fondos de inversión.'
        },
        benefit2: {
          title: 'Comunidad Experta',
          description: 'Conéctate con más de 5.000 inversores exitosos compartiendo estrategias, consejos y celebrando hitos financieros juntos.'
        },
        benefit3: {
          title: 'Planificación Precisa',
          description: 'Cálculos de grado militar aseguran que tus proyecciones financieras sean precisas al centavo, eliminando las conjeturas.'
        }
      },
      urgency: {
        title: 'Cada Día que Esperas Te Cuesta Dinero',
        description: 'Comenzar solo un año más tarde podría costarte más de €50,000 en interés compuesto perdido. El mejor momento para empezar fue ayer. El segundo mejor momento es AHORA.',
        cta: 'Comenzar Mi Viaje de Riqueza',
        note: '✅ 100% Gratis • No Se Requiere Tarjeta de Crédito'
      },
      gettingStarted: {
        title: 'Comienza en 3 Simples Pasos',
        subtitle: 'Toma el control de tus finanzas hoy con nuestras herramientas fáciles de usar',
        step1: {
          title: 'Elige Tu Herramienta',
          description: 'Selecciona entre nuestras calculadoras: interés compuesto, hipotecas, planes de ahorro o comparaciones salariales según tu objetivo financiero.'
        },
        step2: {
          title: 'Ingresa Tus Datos',
          description: 'Introduce tu información financiera actual. Nuestras calculadoras te guían con instrucciones claras y resultados en tiempo real.'
        },
        step3: {
          title: 'Obtén Tu Plan',
          description: 'Recibe proyecciones detalladas e insights accionables. Descarga informes en PDF para seguir tu progreso a lo largo del tiempo.'
        }
      },
      cta: {
        title: '¿Listo para Construir Tu Futuro?',
        subtitle: 'Comienza a construir riqueza hoy con nuestras herramientas financieras gratuitas. ¡Tu viaje hacia la libertad financiera empieza ahora!',
        primary: 'Comenzar Gratis Ahora',
        secondary: 'Ver Planes Premium'
      }
    }
  },
  de: {
    hero: {
      badge: '🚀 Über 500 Nutzer vertrauen uns',
      title: 'Ihr Geld, Ihre Zukunft, Unter Kontrolle',
      subtitle: 'Entdecken Sie die Kraft des Zinseszinses und bauen Sie Vermögen auf, das Generationen überdauert. Schließen Sie sich Tausenden von Nutzern an, die bereits auf ihrer finanziellen Reise sind.',
      cta: 'Vermögen aufbauen beginnen',
      ctaSecondary: 'Wie es funktioniert lernen'
    },
    home: {
      valuePillars: {
        title: 'Bauen Sie Ihre finanzielle Zukunft mit Vertrauen auf',
        subtitle: 'Entdecken Sie die Werkzeuge und das Wissen, die Sie brauchen, um klügere finanzielle Entscheidungen zu treffen und Ihre Ziele zu erreichen',
        pillar1: {
          title: 'Leistungsstarke Rechner',
          description: 'Präzisionswerkzeuge für Zinseszins, Hypotheken, Sparpläne und Gehaltsschätzungen zur Planung jedes Aspekts Ihrer Finanzen.'
        },
        pillar2: {
          title: 'Finanzielle Bildung',
          description: 'Lernen Sie bewährte Strategien zum Investieren, Sparen und Vermögensaufbau mit Expertenführern und praktischen Artikeln.'
        },
        pillar3: {
          title: 'Personalisierte Planung',
          description: 'Erstellen Sie maßgeschneiderte Spar- und Investitionspläne, die auf Ihre einzigartigen Ziele und finanzielle Situation zugeschnitten sind.'
        }
      },
      info: {
        title: 'Lernen Sie mehr über Zinseszins',
        description: 'Zinseszins ist das achte Weltwunder. Wer ihn versteht, verdient ihn; wer ihn nicht versteht, zahlt ihn. Entdecken Sie, wie kleine, regelmäßige Investitionen mit der Zeit exponentiell wachsen können.',
        cta: 'Mehr Ressourcen Anzeigen'
      },
      hook: {
        title: 'Das Geheimnis, das Millionäre Ihnen nicht verraten wollen',
        description: 'Einstein nannte Zinseszins das "8. Weltwunder." Beginnen Sie mit dem systematischen Aufbau Ihres Vermögens und lassen Sie Ihr Geld im Laufe der Zeit für Sie arbeiten.',
        ctaPrimary: 'Meine Zukunft berechnen',
        ctaSecondary: 'Beispiele sehen'
      },
      tools: {
        title: 'Vermögensaufbau-Tools, die wirklich funktionieren',
        useTool: 'Tool verwenden'
      },
      articles: {
        title: 'Empfohlene Finanzartikel',
        subtitle: 'Entdecken Sie unsere beliebtesten Leitfäden, um Ihre persönlichen Finanzen zu meistern und dauerhaften Wohlstand aufzubauen',
        viewAll: 'Alle Artikel anzeigen'
      },
      savings: {
        title: 'Sparplaner: Ihr Leitfaden für intelligentes Familiensparen',
        subtitle: 'Entdecken Sie, wie Sie Geld sparen können mit unserem monatlichen Sparsystem, das darauf ausgelegt ist, Ihr Sparkonto zu maximieren und Ihr gesamtes Sparziel zu erreichen',
        feature1: {
          title: 'Personalisierter monatlicher Sparplan',
          description: 'Erstellen Sie einen monatlichen Sparplan, der auf Ihre finanzielle Situation zugeschnitten ist. Unser Sparplaner hilft Ihnen dabei, realistische Ziele für Ihr Sparkonto zu setzen.'
        },
        feature2: {
          title: 'Optimiertes Familiensparen',
          description: 'Familiensparpläne, denen die ganze Familie folgen kann. Lernen Sie, wie Sie bei Haushaltsausgaben Geld sparen und Ihr verfügbares Geld maximieren können.'
        },
        feature3: {
          title: 'Langfristiges Sparen',
          description: 'Planen Sie Ihr langfristiges Sparen mit präzisen Projektionen. Sehen Sie, wie Ihr Sparkonto wachsen kann, um Ihre gewünschten Gesamtersparnisse zu erreichen.'
        },
        cta: 'Meinen Sparplan erstellen',
        ctaSecondary: 'Sparen lernen'
      },
      benefits: {
        title: '🔥 Warum intelligentes Geld Finanzly wählt',
        subtitle: 'Schließen Sie sich der finanziellen Elite an, die versteht, dass Zeit der wertvollste Vermögenswert beim Vermögensaufbau ist',
        benefit1: {
          title: 'Bewährte Ergebnisse',
          description: 'Unsere Nutzer erreichen durchschnittlich 8,7% jährliche Renditen - übertreffen 90% der traditionellen Sparkonten und viele Investmentfonds.'
        },
        benefit2: {
          title: 'Experten-Community',
          description: 'Vernetzen Sie sich mit über 50.000 erfolgreichen Investoren, die Strategien, Tipps teilen und gemeinsam finanzielle Meilensteine feiern.'
        },
        benefit3: {
          title: 'Präzise Planung',
          description: 'Militärische Berechnungen stellen sicher, dass Ihre Finanzprognosen auf den Cent genau sind und Rätselraten eliminieren.'
        }
      },
      urgency: {
        title: 'Jeder Tag, den Sie warten, kostet Sie Geld',
        description: 'Nur ein Jahr später zu beginnen könnte Sie über €50.000 an verlorenem Zinseszins kosten. Die beste Zeit zu beginnen war gestern. Die zweitbeste Zeit ist JETZT.',
        cta: 'Meine Vermögensreise beginnen',
        note: '✅ 100% Kostenlos • Keine Kreditkarte erforderlich'
      },
      gettingStarted: {
        title: 'Starten Sie in 3 einfachen Schritten',
        subtitle: 'Übernehmen Sie noch heute die Kontrolle über Ihre Finanzen mit unseren benutzerfreundlichen Tools',
        step1: {
          title: 'Wählen Sie Ihr Tool',
          description: 'Wählen Sie aus unseren Rechnern: Zinseszins, Hypotheken, Sparpläne oder Gehaltsvergleiche basierend auf Ihrem finanziellen Ziel.'
        },
        step2: {
          title: 'Geben Sie Ihre Daten ein',
          description: 'Geben Sie Ihre aktuellen Finanzinformationen ein. Unsere Rechner führen Sie mit klaren Anweisungen und Echtzeit-Ergebnissen.'
        },
        step3: {
          title: 'Erhalten Sie Ihren Plan',
          description: 'Erhalten Sie detaillierte Prognosen und umsetzbare Erkenntnisse. Laden Sie PDF-Berichte herunter, um Ihren Fortschritt zu verfolgen.'
        }
      },
      cta: {
        title: 'Bereit, Ihre Zukunft aufzubauen?',
        subtitle: 'Beginnen Sie noch heute mit unseren kostenlosen Finanztools Vermögen aufzubauen. Ihre Reise zur finanziellen Freiheit beginnt jetzt!',
        primary: 'Jetzt kostenlos starten',
        secondary: 'Premium-Pläne ansehen'
      }
    }
  },
  fr: {
    hero: {
      badge: '🚀 Plus de 500 utilisateurs nous font confiance',
      title: 'Votre Argent, Votre Avenir, Sous Contrôle',
      subtitle: 'Découvrez la puissance des intérêts composés et construisez une richesse qui dure des générations. Rejoignez des milliers d\'utilisateurs déjà en route dans leur parcours financier.',
      cta: 'Commencer à Construire la Richesse',
      ctaSecondary: 'Apprendre Comment Ça Marche'
    },
    home: {
      valuePillars: {
        title: 'Construisez Votre Avenir Financier en Toute Confiance',
        subtitle: 'Découvrez les outils et les connaissances dont vous avez besoin pour prendre des décisions financières plus intelligentes et atteindre vos objectifs',
        pillar1: {
          title: 'Calculateurs Puissants',
          description: 'Outils de précision pour les intérêts composés, les hypothèques, les plans d\'épargne et les projections salariales pour planifier chaque aspect de vos finances.'
        },
        pillar2: {
          title: 'Éducation Financière',
          description: 'Apprenez des stratégies éprouvées pour investir, épargner et faire croître votre patrimoine avec des guides d\'experts et des articles pratiques.'
        },
        pillar3: {
          title: 'Planification Personnalisée',
          description: 'Créez des plans d\'épargne et d\'investissement personnalisés adaptés à vos objectifs uniques et à votre situation financière.'
        }
      },
      info: {
        title: "Apprenez-en plus sur l'Intérêt Composé",
        description: "L'intérêt composé est la huitième merveille du monde. Celui qui le comprend en profite ; celui qui l'ignore le paie. Découvrez comment de petits investissements réguliers peuvent croître de manière exponentielle avec le temps.",
        cta: "Voir Plus de Ressources"
      },
      hook: {
        title: 'Le Secret que les Millionnaires ne Veulent pas que Vous Sachiez',
        description: 'Einstein appelait les intérêts composés la "8ème merveille du monde." Commencez à construire votre richesse de manière systématique et regardez votre argent travailler pour vous au fil du temps.',
        ctaPrimary: 'Calculer Mon Avenir',
        ctaSecondary: 'Voir des Exemples'
      },
      tools: {
        title: 'Outils de Construction de Richesse qui Fonctionnent Vraiment',
        useTool: 'Utiliser l\'Outil'
      },
      articles: {
        title: 'Articles Financiers en Vedette',
        subtitle: 'Explorez nos guides les plus populaires pour maîtriser vos finances personnelles et bâtir une richesse durable',
        viewAll: 'Voir Tous les Articles'
      },
      savings: {
        title: 'Planificateur d\'Épargne: Votre Guide pour l\'Épargne Familiale Intelligente',
        subtitle: 'Découvrez comment économiser de l\'argent avec notre système d\'épargne mensuelle conçu pour maximiser votre compte d\'épargne et atteindre votre objectif d\'épargne totale',
        feature1: {
          title: 'Plan d\'Épargne Mensuel Personnalisé',
          description: 'Créez un plan d\'épargne mensuel adapté à votre situation financière. Notre planificateur d\'épargne vous aide à fixer des objectifs réalistes pour votre compte d\'épargne.'
        },
        feature2: {
          title: 'Épargne Familiale Optimisée',
          description: 'Stratégies d\'épargne familiale que toute la famille peut suivre. Apprenez comment économiser de l\'argent sur les dépenses du ménage et maximisez votre argent disponible.'
        },
        feature3: {
          title: 'Épargne à Long Terme',
          description: 'Planifiez votre épargne à long terme avec des projections précises. Voyez comment votre compte d\'épargne peut croître pour atteindre votre épargne totale désirée.'
        },
        cta: 'Créer Mon Plan d\'Épargne',
        ctaSecondary: 'Apprenez à économiser'
      },
      benefits: {
        title: '🔥 Pourquoi l\'Argent Intelligent Choisit Finanzly',
        subtitle: 'Rejoignez l\'élite financière qui comprend que le temps est l\'actif le plus précieux dans la construction de richesse',
        benefit1: {
          title: 'Résultats Prouvés',
          description: 'Nos utilisateurs atteignent en moyenne 8,7% de rendements annuels - surpassant 90% des comptes d\'épargne traditionnels et de nombreux fonds d\'investissement.'
        },
        benefit2: {
          title: 'Communauté d\'Experts',
          description: 'Connectez-vous avec plus de 50 000 investisseurs réussis partageant des stratégies, des conseils et célébrant ensemble les jalons financiers.'
        },
        benefit3: {
          title: 'Planification Précise',
          description: 'Des calculs de grade militaire garantissent que vos projections financières sont précises au centime près, éliminant les approximations.'
        }
      },
      urgency: {
        title: 'Chaque Jour d\'Attente Vous Coûte de l\'Argent',
        description: 'Commencer juste une année plus tard pourrait vous coûter plus de 50 000€ en intérêts composés perdus. Le meilleur moment pour commencer était hier. Le second meilleur moment est MAINTENANT.',
        cta: 'Commencer Mon Voyage de Richesse',
        note: '✅ 100% Gratuit • Aucune Carte de Crédit Requise'
      },
      gettingStarted: {
        title: 'Commencez en 3 Étapes Simples',
        subtitle: 'Prenez le contrôle de vos finances dès aujourd\'hui avec nos outils faciles à utiliser',
        step1: {
          title: 'Choisissez Votre Outil',
          description: 'Sélectionnez parmi nos calculateurs : intérêts composés, hypothèques, plans d\'épargne ou comparaisons salariales selon votre objectif financier.'
        },
        step2: {
          title: 'Entrez Vos Données',
          description: 'Saisissez vos informations financières actuelles. Nos calculateurs vous guident avec des instructions claires et des résultats en temps réel.'
        },
        step3: {
          title: 'Obtenez Votre Plan',
          description: 'Recevez des projections détaillées et des informations exploitables. Téléchargez des rapports PDF pour suivre vos progrès dans le temps.'
        }
      },
      cta: {
        title: 'Prêt à Construire Votre Avenir ?',
        subtitle: 'Commencez à construire votre richesse dès aujourd\'hui avec nos outils financiers gratuits. Votre voyage vers la liberté financière commence maintenant !',
        primary: 'Commencer Gratuitement Maintenant',
        secondary: 'Voir les Plans Premium'
      }
    }
  },
  hi: {
    hero: {
      badge: '🚀 500+ उपयोगकर्ता हम पर भरोसा करते हैं',
      title: 'आपका पैसा, आपका भविष्य, नियंत्रण में',
      subtitle: 'चक्रवृद्धि ब्याज की शक्ति खोजें और ऐसी संपत्ति बनाएं जो पीढ़ियों तक चले। हजारों उपयोगकर्ताओं के साथ जुड़ें जो पहले से ही अपनी वित्तीय यात्रा पर हैं।',
      cta: 'संपत्ति निर्माण शुरू करें',
      ctaSecondary: 'यह कैसे काम करता है जानें'
    },
    home: {
      valuePillars: {
        title: 'आत्मविश्वास के साथ अपना वित्तीय भविष्य बनाएं',
        subtitle: 'स्मार्ट वित्तीय निर्णय लेने और अपने लक्ष्य हासिल करने के लिए आवश्यक उपकरण और ज्ञान खोजें',
        pillar1: {
          title: 'शक्तिशाली कैलकुलेटर',
          description: 'चक्रवृद्धि ब्याज, होम लोन, बचत योजनाओं और वेतन अनुमानों के लिए सटीक उपकरण जो आपके वित्त के हर पहलू की योजना बनाते हैं।'
        },
        pillar2: {
          title: 'वित्तीय शिक्षा',
          description: 'विशेषज्ञ गाइड और व्यावहारिक लेखों के साथ निवेश, बचत और अपनी संपत्ति बढ़ाने की सिद्ध रणनीतियां सीखें।'
        },
        pillar3: {
          title: 'व्यक्तिगत योजना',
          description: 'अपने अनूठे लक्ष्यों और वित्तीय स्थिति के अनुसार अनुकूलित बचत और निवेश योजनाएं बनाएं।'
        }
      },
      info: {
        title: 'चक्रवृद्धि ब्याज के बारे में जानें',
        description: 'चक्रवृद्धि ब्याज दुनिया का आठवां आश्चर्य है। जो इसे समझता है, वह इसे कमाता है; जो नहीं समझता, वह इसे चुकाता है। जानें कि कैसे छोटे, निरंतर निवेश समय के साथ तेजी से बढ़ सकते हैं।',
        cta: 'अधिक संसाधन देखें'
      },
      hook: {
        title: 'वह रहस्य जो करोड़पति आपको नहीं बताना चाहते',
        description: 'आइंस्टाइन ने चक्रवृद्धि ब्याज को "दुनिया का 8वां आश्चर्य" कहा था। व्यवस्थित रूप से अपनी संपत्ति का निर्माण शुरू करें और समय के साथ अपने पैसे को आपके लिए काम करते देखें।',
        ctaPrimary: 'मेरे भविष्य की गणना करें',
        ctaSecondary: 'उदाहरण देखें'
      },
      tools: {
        title: 'संपत्ति निर्माण उपकरण जो वास्तव में काम करते हैं',
        useTool: 'उपकरण का प्रयोग करें'
      },
      articles: {
        title: 'विशेष वित्तीय लेख',
        subtitle: 'अपने व्यक्तिगत वित्त में महारत हासिल करने और स्थायी संपत्ति बनाने के लिए हमारी सबसे लोकप्रिय गाइड देखें',
        viewAll: 'सभी लेख देखें'
      },
      savings: {
        title: 'बचत योजनाकार: स्मार्ट पारिवारिक बचत के लिए आपका गाइड',
        subtitle: 'हमारी मासिक बचत प्रणाली के साथ पैसे बचाने का तरीका खोजें जो आपके बचत खाते को अधिकतम करने और आपके कुल बचत लक्ष्य को प्राप्त करने के लिए डिज़ाइन की गई है',
        feature1: {
          title: 'व्यक्तिगत मासिक बचत योजना',
          description: 'अपनी वित्तीय स्थिति के अनुकूल मासिक बचत योजना बनाएं। हमारा बचत योजनाकार आपके बचत खाते के लिए यथार्थवादी लक्ष्य निर्धारित करने में मदद करता है।'
        },
        feature2: {
          title: 'अनुकूलित पारिवारिक बचत',
          description: 'पारिवारिक बचत रणनीतियां जिनका पूरा परिवार पालन कर सकता है। घरेलू खर्चों पर पैसे बचाना सीखें और अपने उपलब्ध पैसे को अधिकतम करें।'
        },
        feature3: {
          title: 'दीर्घकालिक बचत',
          description: 'सटीक अनुमानों के साथ अपनी दीर्घकालिक बचत की योजना बनाएं। देखें कि आपका बचत खाता कैसे बढ़कर आपकी वांछित कुल बचत तक पहुंच सकता है।'
        },
        cta: 'मेरी बचत योजना बनाएं',
        ctaSecondary: 'और जानें'
      },
      benefits: {
        title: '🔥 स्मार्ट मनी Finanzly क्यों चुनता है',
        subtitle: 'उस वित्तीय अभिजात वर्ग में शामिल हों जो समझते हैं कि समय संपत्ति निर्माण में सबसे मूल्यवान संपत्ति है',
        benefit1: {
          title: 'सिद्ध परिणाम',
          description: 'हमारे उपयोगकर्ता औसतन 8.7% वार्षिक रिटर्न पाते हैं - 90% पारंपरिक बचत खातों और कई निवेश फंडों से बेहतर प्रदर्शन।'
        },
        benefit2: {
          title: 'विशेषज्ञ समुदाय',
          description: '50,000+ सफल निवेशकों के साथ जुड़ें जो रणनीतियां, सुझाव साझा करते हैं और एक साथ वित्तीय मील के पत्थर मनाते हैं।'
        },
        benefit3: {
          title: 'सटीक योजना',
          description: 'मिलिट्री-ग्रेड गणनाएं सुनिश्चित करती हैं कि आपके वित्तीय अनुमान पैसे तक सटीक हों, अनुमान लगाने को समाप्त करते हैं।'
        }
      },
      urgency: {
        title: 'जो भी दिन आप इंतजार करते हैं आपका पैसा खर्च होता है',
        description: 'केवल एक साल बाद शुरू करना आपको खोई हुई चक्रवृद्धि ब्याज में ₹50,000+ का नुकसान हो सकता है। शुरू करने का सबसे अच्छा समय कल था। दूसरा सबसे अच्छा समय अभी है।',
        cta: 'मेरी संपत्ति यात्रा शुरू करें',
        note: '✅ 100% मुफ्त • कोई क्रेडिट कार्ड आवश्यक नहीं'
      },
      gettingStarted: {
        title: '3 सरल कदमों में शुरू करें',
        subtitle: 'हमारे उपयोग में आसान उपकरणों के साथ आज ही अपने वित्त पर नियंत्रण लें',
        step1: {
          title: 'अपना उपकरण चुनें',
          description: 'अपने वित्तीय लक्ष्य के आधार पर हमारे कैलकुलेटर से चुनें: चक्रवृद्धि ब्याज, होम लोन, बचत योजनाएं या वेतन तुलना।'
        },
        step2: {
          title: 'अपना डाटा दर्ज करें',
          description: 'अपनी वर्तमान वित्तीय जानकारी दर्ज करें। हमारे कैलकुलेटर स्पष्ट निर्देशों और रियल-टाइम परिणामों के साथ मार्गदर्शन करते हैं।'
        },
        step3: {
          title: 'अपनी योजना प्राप्त करें',
          description: 'विस्तृत अनुमान और कार्ययोग्य जानकारी प्राप्त करें। समय के साथ अपनी प्रगति को ट्रैक करने के लिए PDF रिपोर्ट डाउनलोड करें।'
        }
      },
      cta: {
        title: 'अपना भविष्य बनाने के लिए तैयार हैं?',
        subtitle: 'हमारे मुफ्त वित्तीय उपकरणों के साथ आज ही संपत्ति बनाना शुरू करें। वित्तीय स्वतंत्रता की ओर आपकी यात्रा अभी शुरू होती है!',
        primary: 'अभी मुफ्त शुरू करें',
        secondary: 'प्रीमियम प्लान देखें'
      }
    }
  }
};